export const validate={json:function(t){try{JSON.parse(t)}catch(t){return!1}return!0}};